"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerGameAggregateParamsSchema = exports.PlayerGameAggregateCountParamsSchema = exports.PlayerGameAggregateFieldSchema = exports.MultiPlayerAggregateParamsSchema = exports.MultiPlayerAggregateCountParamsSchema = exports.MultiPlayerAggregateFieldSchema = exports.MultiPlayerAggregateRequestFieldSchema = exports.PlayerAggregatesParamsSchema = void 0;
const zod_1 = require("zod");
const util_1 = require("../util");
const playerAggregate_1 = require("./playerAggregate");
const query_1 = require("./query");
const util_2 = require("./util");
const translationQuery_1 = require("./translationQuery");
/** Single player aggregate schemas */
const PlayerSequenceAggregateFieldSchema = zod_1.z.union((0, util_2.schemaKeys)(playerAggregate_1.PlayerSequenceAggregateSchema));
exports.PlayerAggregatesParamsSchema = (0, query_1.filterParamsSchema)(PlayerSequenceAggregateFieldSchema).strict();
/** Multi player aggregate schemas */
const MultiPlayerAggregateRequestSchema = zod_1.z.object({
    input: playerAggregate_1.PlayerSequenceAggregateSchema,
    output: playerAggregate_1.MultiPlayerAggregateSchema,
});
exports.MultiPlayerAggregateRequestFieldSchema = (0, util_1.aggregateKeysSchema)(MultiPlayerAggregateRequestSchema, 'output.aggregates');
exports.MultiPlayerAggregateFieldSchema = (0, util_1.aggregateKeysSchema)(playerAggregate_1.MultiPlayerAggregateSchema, 'aggregates');
exports.MultiPlayerAggregateCountParamsSchema = (0, query_1.filterParamsSchema)(exports.MultiPlayerAggregateRequestFieldSchema).strict();
exports.MultiPlayerAggregateParamsSchema = exports.MultiPlayerAggregateCountParamsSchema.extend({
    offset: query_1.OffsetSchema,
    limit: query_1.LimitSchema,
    // Order by only allows keys that are in the response.
    order_by: zod_1.z.record(exports.MultiPlayerAggregateFieldSchema, query_1.SortOrderSchema).optional(),
})
    .extend(translationQuery_1.LanguageParamsSchema.shape)
    .extend(query_1.ColumnsParamSchema.shape)
    .strict();
/** Single player across multiple games schemas */
const PlayerGameAggregateRequestSchema = zod_1.z.object({
    input: playerAggregate_1.PlayerSequenceAggregateSchema,
    output: playerAggregate_1.PlayerGameAggregateSchema,
});
const PlayerGameAggregateRequestFieldSchema = (0, util_1.aggregateKeysSchema)(PlayerGameAggregateRequestSchema, 'output.aggregates');
exports.PlayerGameAggregateFieldSchema = (0, util_1.aggregateKeysSchema)(playerAggregate_1.PlayerGameAggregateSchema, 'aggregates');
exports.PlayerGameAggregateCountParamsSchema = (0, query_1.filterParamsSchema)(PlayerGameAggregateRequestFieldSchema).strict();
exports.PlayerGameAggregateParamsSchema = exports.PlayerGameAggregateCountParamsSchema.extend({
    offset: query_1.OffsetSchema,
    limit: query_1.LimitSchema,
    // Order by only allows keys that are in the response.
    order_by: zod_1.z.record(exports.PlayerGameAggregateFieldSchema, query_1.SortOrderSchema).optional(),
})
    .extend(translationQuery_1.LanguageParamsSchema.shape)
    .extend(query_1.ColumnsParamSchema.shape)
    .strict();
//# sourceMappingURL=playerAggregateQuery.js.map